import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';


const aboutData = [
  {
    id: 1,
    image: '/images/Artists/SimoneBernini.jpg',
    link: '/artists',
    title: 'SIMONE BERNINI X Stihl Timbersports, Allianz Cloud',
    description: 'Live show ',
  },
  {
    id: 2,
    image: '/images/About/Settembre.png',
    link: 'https://www.youtube.com/watch?v=txuIcQsOb1A',
    title: '"ORO ORO" OFFICIAL COVER ANDREA SETTEMBRE',
    description: 'Now single "ORO ORO" out on Spotify',
  },
  {
    id: 3,
    image: '/images/Artists/LowrahStamina.jpeg',
    link: 'https://www.youtube.com/watch?v=hd8QA0LcR8I',
    title: '"STAMINA" OFFICIAL VIDEOCLIP LOWRAH',
    description: 'Now single "Stamina" out on Youtube',

  }
];

function About() {
  
  return (
    <section className="about">
      <div className="about__overlay"></div>
      <Container fluid>
        <Row className="g-4 justify-content-center"> {/* Centratura e spaziatura */}
          {aboutData.map((item) => (
            <Col xs={12} sm={6} md={4} lg={3} key={item.id}>
              <div className="about__card">
                <a href={item.link} className="about__card-link">
                  <div className="about__card-image">
                    <Image src={item.image} alt={item.title} fluid className={`about__card-img ${item.id === 1 ? 'scale-image' : ''}`}  />
                  </div>
                  <h3 className="about__card-title">{item.title}</h3>
                  <p className="about__card-description">{item.description}</p>
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default About;
